import { styled } from '@mui/material';

export const ActionsW = styled('div')`
  position: relative;
  z-index: 10;

  @media (max-width: 1023px) {
    width: 100%;
  }
`;
